// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App_app-wrapper__uHePm{max-width:600px}.App_app-wrapper__uHePm *{box-sizing:border-box;font-family:\"Hiragino Kaku Gothic ProN\",\"Meiryo\",\"sans-serif\"}", "",{"version":3,"sources":["webpack://./src/App.module.scss"],"names":[],"mappings":"AAAA,wBACC,eAAA,CAGC,0BACC,qBAAA,CACA,6DAAA","sourcesContent":[".app-wrapper {\n\tmax-width: 600px;\n\n\t:global {\n\t\t* {\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-family: 'Hiragino Kaku Gothic ProN', 'Meiryo', 'sans-serif';\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-wrapper": "App_app-wrapper__uHePm"
};
export default ___CSS_LOADER_EXPORT___;
